var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDwell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.804 18.61c1.228-1.79 3.266-4.98 4.222-7.278.314.138.637.264.974.361-1.368 3.303-4.584 7.845-4.756 8.087a.54.54 0 0 1-.44.22.54.54 0 0 1-.44-.22C6.143 19.472 1 12.208 1 9.388 1 6.417 3.604 4 6.804 4c.037 0 .073.005.11.005a6.365 6.365 0 0 0-.101.975h-.01c-2.618 0-4.748 1.977-4.748 4.408 0 1.91 3.103 6.824 4.749 9.222zm8.352-12.578a.532.532 0 0 0 0-1.064h-1.124V2.602a.532.532 0 0 0-1.064 0V5.5c0 .294.238.532.532.532h1.656zM13.5 0C16.532 0 19 2.468 19 5.5S16.532 11 13.5 11A5.507 5.507 0 0 1 8 5.5C8 2.468 10.468 0 13.5 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d5473f",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwell);
export default __webpack_public_path__ + "static/media/dwell.4b43756743f24bcd1d1297eb10ec4866.svg";
export { ForwardRef as ReactComponent };